import React from "react";
import { markdown } from "markdown";

export default ({
  character,
  play,
  description: { description },
  dates,
  link
}) => (
  <article className="timeline-entry">
    <div className="timeline-entry-inner">
      <div className="timeline-icon color-1">
        <i className="icon-head" />
      </div>
      <div className="timeline-label">
        <h2>
          <a href={link || null} target="_blank">
            {character}, {play}
          </a>
          <span>{dates}</span>
        </h2>
        <p dangerouslySetInnerHTML={{ __html: markdown.toHTML(description) }} />
      </div>
    </div>
  </article>
);



// WEBPACK FOOTER //
// ./src/components/experience.js